module.exports = __webpack_public_path__ + "static/media/joint.dcdc32ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/joint.svg
// module id = 352
// module chunks = 0